import FechamentoPeriodo from "views/admin/relatorio/FechamentoPeriodo.js";
import RelatorioIA from "./views/admin/relatorio/RelatorioIA.js";
import RelatorioIRD from "./views/admin/relatorio/RelatorioIRD.js";
import RelatorioIF from "./views/admin/relatorio/RelatorioIF.js";
import RelatorioADC from "./views/admin/relatorio/RelatorioADC.js";

var routes = [
  {
    path: "/FechamentoPeriodo",
    name: "Fechamento de Período",
    icon: "",
    component: FechamentoPeriodo,
    layout: "/blank",
    sidebar: false
  },
  {
    path: "/RelatorioIRD",
    name: "Relatório IRD",
    icon: "",
    component: RelatorioIRD,
    layout: "/blank",
    sidebar: false
  },
  {
    path: "/RelatorioIA",
    name: "Relatório IA",
    icon: "",
    component: RelatorioIA,
    layout: "/blank",
    sidebar: false
  },
  {
    path: "/RelatorioIF",
    name: "Relatório IF",
    icon: "",
    component: RelatorioIF,
    layout: "/blank",
    sidebar: false
  },
  {
    path: "/RelatorioADC",
    name: "Relatório ADC",
    icon: "",
    component: RelatorioADC,
    layout: "/blank",
    sidebar: false
  }
];

export default routes;
